import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BrowseSubjectsCms } from "../../interfaces/browse-subjects-cms.interface";
import { lmwBaseRoutes } from "../../routing/route-locales/lmw-base-routes";
import { environment } from "../../../../../environments/environment";
import { lmwAuthLazyLoadedState } from '../../../auth-process/common/routing/route-locales/app-routes';
import { signInLazyLoaded } from '../../../auth-process/sign-in/routing/route-locales/sign-in-routes';
import { signInUsernameState } from '../../../auth-process/sign-in/routing/sign-in.states';
import { registrationLazyLoaded } from '../../../auth-process/registration/routing/route-locales/registration-routes';

@Component({
  selector: 'lmw-base-browse-subjects',
  templateUrl: './browse-subjects.component.html',
  styleUrls: ['./browse-subjects.component.scss']
})
export class BrowseSubjectsComponent implements OnInit {

  public userSignedIn = false;
  public subjects;
  public browseSubjectsCms: BrowseSubjectsCms;
  public mobileBackButtonText = lmwBaseRoutes.homeLinkText;
  public language: string = environment.language;
  public registrationLink = `/${lmwAuthLazyLoadedState.path}/${registrationLazyLoaded.path}`;
  public signInUsernamePath = `/${lmwAuthLazyLoadedState.path}/${signInLazyLoaded.path}/${signInUsernameState.path}`;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.userSignedIn = this.route.snapshot.data.userSignedIn;
    this.subjects = this.route.snapshot.data.subjects;
    this.browseSubjectsCms = this.route.snapshot.data.cmsData
  }

}
